export default function Field({ label, value, onChange, placeholder, type = 'text' }) {
  return (
    <div>
      <label className="text-xs text-neutral-400 uppercase tracking-wider mb-2 block">
        {label}
      </label>
      <input
        type={type}
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full px-4 py-2.5 bg-black/40 border border-neutral-800 rounded-lg text-white placeholder-neutral-600 focus:outline-none focus:border-brand-gold/50 text-sm"
      />
    </div>
  );
}
